import UsersIcon from "@heroicons/react/24/solid/UsersIcon";
import {
  Avatar,
  Card,
  CardContent,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";

const CardChildrenInProduction = (props) => {
  const { sx, personAggregate, graphChildren, dashboard } = props;
  const childrenInProdcution =
    personAggregate?.people?.peopleProduction ?? graphChildren;
  return (
    <Card sx={sx}>
      <CardContent>
        <Stack
          alignItems="flex-start"
          direction="row"
          justifyContent="space-between"
          spacing={3}
        >
          <Stack spacing={1}>
            <Typography color="text.secondary" variant="overline">
              {dashboard ? "segnalatori lv.1+" : "segnalatori attivi lv.1+"}
            </Typography>
            <Typography variant="h4">{`${childrenInProdcution}`}</Typography>
          </Stack>
          <Avatar
            sx={{
              backgroundColor: "childrenInProduction.main",
              height: 56,
              width: 56,
            }}
          >
            <SvgIcon>
              <UsersIcon />
            </SvgIcon>
          </Avatar>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default CardChildrenInProduction;
